// App.js
import React from 'react';
import Navbar from './Componentes/Navbar';
import Hero from './Componentes/Hero';
import Sobre from './Sobre/Sobre';
import Projetos from './Projeto/Projeto';
import Contato from './Contato/Contato'
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Habilidades from './Habilidades/Hability';


function App() {
  return (
    <>
      <Navbar />
      <Hero /> {/* Hero agora é o primeiro elemento visual */}
      
      <div className="App-content" style={{ paddingTop: '60px' }}>
        {/* Removi o id="inicio" duplicado */}
        <Sobre />

        <Projetos />

        <Habilidades />

        <Contato />
      </div>
    </>
  );
}

export default App;